module.exports = __webpack_public_path__ + "gf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gf.svg
// module id = 561
// module chunks = 0